<div class="row">

  <!-- card-width="250"  [messages]="messages" [masks]="masks"  [placeholders]="{name:cardOwnerName}"-->
  <div [formGroup]="mainForm" formatting="false" debug="true">

    <div class="row">
      <div class="col-md-12">
        <mat-form-field class="full-width">
          <input matInput type="text" formControlName="name" placeholder="Nome" />
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <mat-form-field class="full-width">
          <input matInput type="text" formControlName="document" placeholder="Cpf/Cnpj" />
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <mat-form-field class="full-width">
          <input matInput type="text" formControlName="phone" placeholder="Celular" />
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <mat-form-field class="full-width">
          <input matInput type="text" formControlName="address" placeholder="Endereço" />
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <mat-form-field class="full-width">
          <input matInput type="text" formControlName="city" placeholder="Cidade" />
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
       <mat-form-field class="full-width">
          <intelli-selector placeholder="Estado" [options]="ufOptions"  formControlName="state"> </intelli-selector>
        </mat-form-field> 


      </div>
      <div class="row">
        <div class="col-md-12">
          <mat-form-field class="full-width">
            <input matInput type="text" formControlName="zipcode" placeholder="Cep" />
          </mat-form-field>
        </div>
      </div>
    </div>


  </div>